import { Avatar as AntdAvatar } from "antd";
import React from "react";
export interface AvatarProps {
  /** The size of the avatar (small, default, large, or a number) */
  size?: "small" | "default" | "large" | number;
  /** The shape of the avatar (circle or square) */
  shape?: "circle" | "square";
  /** The source URL of the avatar image */
  src?: string;
  /** The alternative text for the avatar image */
  alt?: string;
  /** The text content to display as the avatar if no image is provided */
  text?: string;
  /** The background color of the avatar when displaying text */
  backgroundColor?: string;
  /** Custom className for additional styling */
  className?: string;
  /** Tooltip text for additional accessibility or information */
  tooltip?: string;
}
const Avatar: React.FC<AvatarProps> = ({
  size = "default",
  shape = "circle",
  src,
  alt,
  text,
  backgroundColor,
  className,
  tooltip,
}) => {
  return (
    <div
      className={className}
      title={tooltip}
      aria-label={alt || text || "Avatar"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: text && !src ? backgroundColor : undefined,
        borderRadius: shape === "circle" ? "50%" : undefined,
      }}
    >
      <AntdAvatar size={size} shape={shape} src={src} alt={alt}>
        {text}
      </AntdAvatar>
    </div>
  );
};
export default Avatar;
